import { createFileRoute } from "@tanstack/react-router";
import { useEffect, type JSX } from "react";

import { graphql } from "@repo/graphql-types";
import Left from "@repo/icons/default/Left";

import { AppointmentReceivingOptionsList } from "@/components/appointment/appointment-receiving-options-list";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { PendingComponent } from "@/components/ui/loading/pending-component";
import { useClearAppointmentReceivingOptionDrafts } from "@/hooks/use-appointment-receiving-option-form-draft";
import { useGraphQL } from "@/hooks/use-graphql";

const AppointmentReceivingOptionsPageQuery = graphql(/* GraphQL */ `
  query AppointmentReceivingOptionsPageQuery {
    ...AppointmentReceivingOptionsListQueryFragment
  }
`);

const AppointmentReceivingOptionsPage = (): JSX.Element => {
  const queryResult = useGraphQL(AppointmentReceivingOptionsPageQuery);
  const { data } = queryResult;

  const clearAppointmentReceivingOptionDrafts =
    useClearAppointmentReceivingOptionDrafts();

  useEffect(() => {
    clearAppointmentReceivingOptionDrafts();
  }, [clearAppointmentReceivingOptionDrafts]);

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Convênios" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? (
            <AppointmentReceivingOptionsList appointmentReceivingOptions={data} />
          ) : (
            <FullPageSpinner />
          )}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-receiving-options/",
)({
  component: AppointmentReceivingOptionsPage,
  pendingComponent: () => <PendingComponent title="Convênios" />,
});
